/* eslint-disable @typescript-eslint/no-explicit-any */
export function ensureVcdkContentSwitcherWrap() {
    const WIN_FLAG = "__vcdkContentSwitcherWrapPatched__";
    if ((window as any)[WIN_FLAG]) {
        return;
    }
    (window as any)[WIN_FLAG] = true;

    const CSS = `
@media (max-width: 768px) {
  ul[role="tablist"] {
    flex-wrap: wrap !important;
    justify-content: center !important;
  }
}
`;
    const vcdkContentSwitcherTag = "vcdk-content-switcher";
    const inject = (shadow: ShadowRoot | null | undefined) => {
        if (!shadow) {
            return;
        }
        if (shadow.querySelector("style[data-vcdk-wrap]")) {
            return;
        }
        const style = document.createElement("style");
        style.setAttribute("data-vcdk-wrap", "true");
        style.textContent = CSS;
        shadow.appendChild(style);
    };

    const origAttach = Element.prototype.attachShadow;
    Element.prototype.attachShadow = function (
        init: ShadowRootInit
    ): ShadowRoot {
        const shadow = origAttach.call(this, init);

        if (
            (this as HTMLElement).tagName?.toLowerCase() ===
            vcdkContentSwitcherTag
        ) {
            inject(shadow);
        }
        return shadow;
    };

    customElements.whenDefined(vcdkContentSwitcherTag).then(() => {
        document.querySelectorAll(vcdkContentSwitcherTag).forEach((el) => {
            const sr = (el as any).shadowRoot;
            if (sr) {
                inject(sr);
            } else {
                requestAnimationFrame(() => inject((el as any).shadowRoot));
            }
        });
    });
}
